<script>
  import { Col, Row } from 'sveltestrap';
  import IoIosCalendar from 'svelte-icons/io/IoIosCalendar.svelte'

  export let tags = ["Tag1", "Tag2"];
</script>

<style>
  .tags ul {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    list-style: none;
    padding-left: 0;
  }

  /* .tags li + li {
    margin-right: .5rem;
  } */

  .tags li {
    color: var(--palette-pop);
    font-size: .75rem;
    height: 1.5rem;
    line-height: 1.5rem;
    letter-spacing: 1px;
    padding: 0 .5rem;
    text-align: center;
    white-space: nowrap;
    background-color: var(--palette-grad2);
    color: var(--palette-white);
    font-size: 12px;
    line-height: 22px;
    margin-top: 0.5rem;
    margin-right: .5rem;
  }

  .tagline {
    font-size: 2rem;
    font-family: 'Deja Vu', sans-serif;
    float: left;
    position: relative;
    min-height: 150px;
    font-weight: 900;
    max-width: 450px;
    text-align: left;
    padding-top: 25px;
    padding-bottom: 50px;
    line-height: 1;
    font-stretch: extra-condensed;
    padding-left: 25px;
    color: var(--palette-white);
  }
  .cardMain {
    background-size: cover;
    overflow: hidden;
    background-color: var(--palette-white);
    margin-top: 25px;
    margin-bottom: 25px;
    width: 100%;
    padding-left: 15px;
    padding-right: 15px;
  }

  .shape {
    height: 275px;
    width: 425px;
    background-color: var(--palette-grad2);
    margin-left: -40px;
    position: absolute;
    top: -70px;
    transform: rotate(15deg);
  }

  @media screen and (max-width: 991px) {
    .tagline {
      max-width: 320px;
      font-size: 1.5rem;
    }

    .shape {
      width: 325px;
    }
  }

  .button {
    display: inline-block;
    margin-top: 25px;
    padding: 5px 15px 5px 15px;
    font-size: 12px;
    transition: all 0.4s;
    background-color: var(--palette-white);
    color: var(--palette-grad2) !important;
    line-height: 18px;
    font-weight: 400;
    font-family: 'Poppins';
  }

  .description {
    color: var(--palette-grad2);
    text-align: left;
    margin-top: 15px;
    margin-bottom: 25px;
  }

  .title {
    text-align: left;
    color: var(--palette-pop);
    font-size: 2rem;
    margin-top: 25px;
    margin-bottom: 5px;
  }

  .date {
    color: var(--palette-grad2);
    text-align: left;
  }

  .dateText {
    position: relative;
    top: 2px;
    display: inline-block;
    font-family: "DejaVu Sans";
    font-weight: 400;
  }
</style>

<div class="cardMain" style="margin-top: 25px; width: 100%">
  <Row>
    <Col xs="12" md="5">
      <div class="shape"></div>
      <div class="tagline">
        <div>
          <slot name="company">
            COMPANY
          </slot>
        </div>
        <div class="button">
          <slot name="role">
            Role
          </slot>
        </div>
      </div>
    </Col>
    <Col xs="12" md="7">
      <div class="title">
        <slot name="title">Title</slot>
      </div>
      <!-- <div class="date">
        <div class="icontext" style="padding-top: 0px !important">
          <div class="icon">
            <IoIosCalendar />
          </div>
          <div class="dateText">
            <slot name="date">Date</slot>
          </div>
        </div>
      </div> -->
      <div class="description">
        <slot name="description">
          Description
        </slot>
      </div>
    </Col>
  </Row>
  <Row>
    <Col xs="12" md="5">
      <div class="date">
      </div>
    </Col>
    <Col xs="12" md="7">
      <div class="tags">
        <ul>
          {#each tags as tag}
            <li>{tag}</li>
          {/each}
        </ul>
      </div>
    </Col>
  </Row>
</div>
